import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { BreadCrumbs } from '@common/react/components/UI/BreadCrumbs/BreadCrumbs';
import ServerPageProvider from '@common/react/components/UI/lang/SeverPageProviderWithLang/ServerpageProviderWithLang';

import OfficesInfoList from '@app/components/Pages/Home/OfficeInfoBlock';
import ShareLinks from '@app/components/UI/ShareLinks/ShareLinks';
import ContactUsForm from '@app/components/Forms/ContactUs/ContactUsForm';

import '@app/scss/pages/contacts.scss';

const Contacts: React.FC = () => {
	const { t } = useTranslation();
	const title = t('site.Contacts');

	return <div className="inner-page contacts-page container">
		<div className="clearfix">
			<BreadCrumbs title={title} />
			<ShareLinks />
		</div>
		<ServerPageProvider loader={<></>} inner={(s) => <></>} notFoundComponent={<></>} />
		<div className="inner-page__headline text-center mt10">
			<h1>{title}</h1>
		</div>
		<div className="row">
			<OfficesInfoList titleAsH2 />
		</div>
		<div className="contacts-page__form">
			<div className="inner-page__headline text-center">
				<h2>{t('site.Schedule an Appointment Now')}</h2>
			</div>
			<ContactUsForm className="general-form" />
		</div>
	</div>;
};

export default Contacts;
